import { TTransientProps } from '../../types';

import { IPanelGroupProps } from './types';

export const TRANSIENT_PROPS: Array<
  TTransientProps<IPanelGroupProps, HTMLElement>
> = ['panelsPerLine', 'equalWidth'];
